import React from 'react';
import {useTranslation} from 'react-i18next';
import {Button, Dialog, DialogContent, DialogFooter} from '@taopix/taopix-design-system';
import {useUserFlowState} from '../../Context/UserFlow/UserFlowContext';
import {UserFlowType} from '../../../Facade/UserFlow/UserFlowFacade';
import {UserFlowStep} from '../../../Facade/UserFlow/BaseUserFlow';

type SubmittedChangesNotificationProps = {
  open: boolean;
};

const SubmittedChangesNotification = ({open}: SubmittedChangesNotificationProps) => {
  const userFlow = useUserFlowState();
  const {t} = useTranslation();

  const closeDialog = () => {
    userFlow.activateUserFlow(UserFlowType.Auth);
    userFlow.setCurrentStep(`${UserFlowType.Auth}.${UserFlowStep.Logout}`);
  };

  return (
    <Dialog
      open={open}
      theme={'tpx-theme-dialogs'}
      themeTip="Dialogs"
      title={t('*:str_TitleInfo')}
      aria-live="assertive"
    >
      <DialogContent className={''}>
        <p>{t('*:str_MessageSubmittedChanges')}</p>
      </DialogContent>
      <DialogFooter>
        <Button label={t('*:str_ButtonClose')} buttonStyle={'primary'} onClick={closeDialog} />
      </DialogFooter>
    </Dialog>
  );
};

export default SubmittedChangesNotification;
